import { useSelector } from 'react-redux';

import { selectIsWhatsAppMessageChannelGAFlagOn } from 'core/userContext';
import { TemplateMetadata } from 'modules/templateEditor/common/types';
import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { InfoFill16 } from 'ui/icons';
import { colors } from 'ui/theme';

import { displayContent } from './AttachTemplateTakeover.constant';
import { WhatsAppWarningBanner } from 'modules/campaigns/editor/components/WhatsAppWarningBanner';
import { getTemplateWhatsAppWarnings } from '../utils';

type TemplatePickerBannerProps = {
  selectedTemplate: TemplateMetadata | null;
  isApiTriggered: boolean;
};

export const WhatsAppTemplatePickerBanner = ({
  selectedTemplate,
  isApiTriggered,
}: TemplatePickerBannerProps) => {
  const isWhatsAppGAEnabled = useSelector(selectIsWhatsAppMessageChannelGAFlagOn);
  const { whatsAppLocaleContent } = selectedTemplate || {};
  const warnings = isWhatsAppGAEnabled ? getTemplateWhatsAppWarnings(whatsAppLocaleContent) : [];
  return (
    <>
      {isWhatsAppGAEnabled && !!selectedTemplate && !!warnings.length ? (
        <WhatsAppWarningBanner warnings={warnings} />
      ) : (
        <Banner Icon={<InfoFill16 color={colors.iconInfo} />} variant={BannerVariants.INFO}>
          {isApiTriggered
            ? displayContent.whatsAppBannerApiTriggered
            : displayContent.whatsAppBannerBlast}
        </Banner>
      )}
    </>
  );
};
